module.exports = __webpack_public_path__ + "img/114.rocedure_for_making_an_appointment.51aa1356.svg";